module.exports = __webpack_public_path__ + "static/media/return-rejected.cfcb6a2d.svg";